import React from "react";
import { Helmet } from "react-helmet";

import RegisterStyles from "views/open/Register.module.scss";
import { RegisterForm } from "components/login/RegisterForm";

export const Register = () => {
  return (
    <div id={"gb-open"}>
      <Helmet>
        <title>Minha Glambox : Registro</title>
      </Helmet>
      <div className={RegisterStyles["register"]}>
        <div className={RegisterStyles["register__form"]}>
          <h5>Registre-se!</h5>

          <RegisterForm/>
        </div>
      </div>
    </div>
  );
};
